import type { Owner } from "../types";

interface UserEmailColumnProps {
  row: Owner;
}

export const UserEmailColumn = ({ row }: UserEmailColumnProps) => {
  return <span>{row.email || "N/A"}</span>;
};